export default {"src":"/_next/static/media/ga.75f65d15.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};